module.exports = __webpack_public_path__ + "img/51e9d90.jpg";